/* eslint-disable max-len */
export const messages = {
  addPayment: 'Add payment method',
  deleteCard: 'Delete card',
  emptyStatePaymentMethodsHeader: 'No payment method has been added',
  emptyStatePaymentMethodsText:
    'You can book by card, or pay by invoice. Simply select Add Payment Method to complete your business account set up.',
  emptyStateCardsHeader: 'No cards has been added',
};
